// utils.js
import html2pdf from 'html2pdf.js';

export function downloadPDF(printRef) {
  const element = printRef.current;

  if (!element) {
    console.error("Print element not found!");
    return;
  }

  // 1. Find the history-container div inside CodeHistory
  const historyContainer = element.querySelector('.history-container');
  if (!historyContainer) {
    console.error("history-container not found inside printRef!");
    return;
  }

  // Save original styles for printRef.current
  const originalStyle = {
    height: element.style.height,
    overflow: element.style.overflow,
    maxHeight: element.style.maxHeight,
    position: element.style.position,
    display: element.style.display,
  };

  // Save original styles for history-container
  const originalHistoryStyle = {
    height: historyContainer.style.height,
    overflow: historyContainer.style.overflow,
    maxHeight: historyContainer.style.maxHeight,
  };

  // Check for parent constraints of printRef.current (just in case)
  const parentElement = element.parentElement;
  const originalParentStyle = {
    overflow: parentElement ? parentElement.style.overflow : '',
    maxHeight: parentElement ? parentElement.style.maxHeight : '',
    height: parentElement ? parentElement.style.height : '',
  };

  // 2. Modify styles to show all content for capture
  element.style.height = 'auto';
  element.style.overflow = 'visible';
  element.style.maxHeight = 'none';
  element.style.position = 'static';
  element.style.display = 'block';

  historyContainer.style.height = 'auto';
  historyContainer.style.overflow = 'visible';
  historyContainer.style.maxHeight = 'none';

  if (parentElement) {
    parentElement.style.overflow = 'visible';
    parentElement.style.maxHeight = 'none';
    parentElement.style.height = 'auto';
  }

  // Force DOM reflow to ensure styles are applied
  const forceReflow = () => {
    return new Promise(resolve => {
      setTimeout(() => {
        // Trigger reflow by accessing offsetHeight
        // eslint-disable-next-line no-unused-expressions
        element.offsetHeight; // Line 68: Suppress the ESLint warning
        resolve();
      }, 0);
    });
  };

  // Calculate the full height of the content after removing constraints
  const fullHeight = element.scrollHeight;
  console.log("Full content height for PDF:", fullHeight);

//   const a4WidthInches = 8.27;
//   const marginInches = 0.5;
//   const contentWidthInches = a4WidthInches - 2 * marginInches;
//   const dpi = 96;
//   const contentWidthPixels = contentWidthInches * dpi;

  const style = document.createElement('style');
  style.innerHTML = `
    .print-area {
     
      box-sizing: border-box;
      font-size: 13px !important;
      overflow: visible !important;
      height: auto !important;
    }
    .print-area * {
   
      box-sizing: border-box;
      font-size: 13px !important;
      white-space: normal;
      overflow-wrap: break-word;
    }
    .history-container {
      height: auto !important;
      overflow: visible !important;
      max-height: none !important;
    }
    .page-break {
      page-break-before: always;
    }
    .page-break-inside {
      page-break-inside: avoid;
    }
    .history-dropdown-container {
      page-break-inside: auto;
    }
    .history-item-wrapper {
      page-break-inside: avoid;
    }
  `;
  document.head.appendChild(style);

  const now = new Date();
  const formattedDate = now.toLocaleDateString('en-GB').replace(/\//g, '-');
  const formattedTime = now.toLocaleTimeString('en-GB').replace(/:/g, '-');
  const fileName = `HCS-CodingPathHistory-${formattedDate}-${formattedTime}.pdf`;

  const options = {
    margin: [0.5,0.5,0.5,0.5],
    filename: fileName,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: {
      scale: 1,
      logging: true,
      useCORS: true,
    //   width: contentWidthPixels,
      height: fullHeight,
      windowHeight: fullHeight,
      scrollY: 0,
    },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
    pagebreak: { 
      mode: ['css', 'legacy'],
      before: '.page-break',
      avoid: '.page-break-inside',
    },
  };

  forceReflow().then(() => {
    html2pdf().set(options).from(element).save().then(() => {
      element.style.height = originalStyle.height;
      element.style.overflow = originalStyle.overflow;
      element.style.maxHeight = originalStyle.maxHeight;
      element.style.position = originalStyle.position;
      element.style.display = originalStyle.display;

      historyContainer.style.height = originalHistoryStyle.height;
      historyContainer.style.overflow = originalHistoryStyle.overflow;
      historyContainer.style.maxHeight = originalHistoryStyle.maxHeight;

      if (parentElement) {
        parentElement.style.overflow = originalParentStyle.overflow;
        parentElement.style.maxHeight = originalParentStyle.maxHeight;
        parentElement.style.height = originalParentStyle.height;
      }

      if (style.parentNode) {
        style.parentNode.removeChild(style);
      }
    }).catch(err => {
      console.error("Error generating PDF:", err);
      element.style.height = originalStyle.height;
      element.style.overflow = originalStyle.overflow;
      element.style.maxHeight = originalStyle.maxHeight;
      element.style.position = originalStyle.position;
      element.style.display = originalStyle.display;

      historyContainer.style.height = originalHistoryStyle.height;
      historyContainer.style.overflow = originalHistoryStyle.overflow;
      historyContainer.style.maxHeight = originalHistoryStyle.maxHeight;

      if (parentElement) {
        parentElement.style.overflow = originalParentStyle.overflow;
        parentElement.style.maxHeight = originalParentStyle.maxHeight;
        parentElement.style.height = originalParentStyle.height;
      }

      if (style.parentNode) {
        style.parentNode.removeChild(style);
      }
    });
  });
}


 // const handleDownloadPdf = () => {
  //   const element = printRef.current;
  
  //   // Set font size if needed
  //   element.style.fontSize = '14px';
  
  //   // Generate custom filename
  //   const now = new Date();
  //   const formattedDate = now.toLocaleDateString('en-GB').replace(/\//g, '-');
  //   const formattedTime = now.toLocaleTimeString('en-GB').replace(/:/g, '-');
  //   const fileName = `HCS-CodingPathHistory-${formattedDate}-${formattedTime}.pdf`;
  
  //   // Download PDF
  //   const options = {
  //     margin: 0.5,
  //     filename: fileName,
  //     image: { type: 'jpeg', quality: 0.98 },
  //     html2canvas: { scale: 2 },
  //     jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
  //   };
  
  //   html2pdf().set(options).from(element).save();
  // };

  // const handleDownloadPdf = () => {
  //   const element = printRef.current;
  
  //   // Set font size if needed
  //   element.style.fontSize = '14px';
  
  //   // Ensure page breaks in the content
  //   const style = document.createElement('style');
  //   style.innerHTML = `
  //     /* Ensure page break handling for content */
  //     .page-break { 
  //       page-break-before: always;
  //     }
  //     .page-break-inside { 
  //       page-break-inside: avoid;
  //     }
  //     .print-area {
  //       width: 100%;
  //       padding: 10px;
  //       overflow: hidden; /* Changed to avoid overflow issues */
  //     }
  //   `;
  //   document.head.appendChild(style);
  
  //   // Generate custom filename with timestamp
  //   const now = new Date();
  //   const formattedDate = now.toLocaleDateString('en-GB').replace(/\//g, '-');
  //   const formattedTime = now.toLocaleTimeString('en-GB').replace(/:/g, '-');
  //   const fileName = `HCS-CodingPathHistory-${formattedDate}-${formattedTime}.pdf`;
  
  //   // Download PDF with html2pdf options
  //   const options = {
  //     margin: [0.5, 0.5, 0.5, 0.5], // Set all margins (top, left, bottom, right)
  //     filename: fileName,
  //     image: { type: 'jpeg', quality: 0.98 },
  //     html2canvas: { scale: 2, logging: true, useCORS: true }, // Ensure high quality
  //     jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }, // A4 format, portrait orientation
  //     pagebreak: { mode: 'auto', before: '.page-break' }, // Automatic page breaks
  //   };
  
  //   // Set options for html2pdf and create the PDF
  //   html2pdf().set(options).from(element).save();
  // };
  
//   const handleDownloadPdf = () => {
//   const element = printRef.current;

//   if (!element) {
//       console.error("Print element not found!");
//       return;
//   }

//   // 1. Save original styles that might cause scrolling
//   const originalStyle = {
//     height: element.style.height,
//     overflow: element.style.overflow,
//     maxHeight: element.style.maxHeight,
//     // Save any other styles that might constrain height or cause overflow
//   };

//   // 2. Modify styles to show all content for capture
//   // Remove height constraints and make overflow visible
//   element.style.height = 'auto';
//   element.style.overflow = 'visible';
//   element.style.maxHeight = 'none'; // Important if you use max-height

//   // You might also need to check parent elements if they are the ones
//   // enforcing the fixed height/overflow and apply similar temporary styles.
//   // For example:
//   // const parentElement = element.parentElement;
//   // const originalParentStyle = { ... };
//   // parentElement.style.height = 'auto'; // Or modify as needed

//   // Set font size if needed (already in your code)
//   element.style.fontSize = '14px';

//   // Ensure page breaks in the content by adding print styles
//   // Make sure these styles don't reintroduce unwanted overflow/height constraints
//   const style = document.createElement('style');
//   style.innerHTML = `
//     /* Ensure page break handling for content */
//     .page-break {
//       page-break-before: always;
//     }
//     .page-break-inside {
//       page-break-inside: avoid;
//     }
//     .print-area {
//       width: 100%;
//       padding: 10px;
//       /* Ensure no fixed height or hidden overflow that would cut content */
//       /* overflow: visible !important; Remove or override if present in other CSS */
//       /* height: auto !important; Remove or override if present in other CSS */
//     }
//     /* Add any other specific print styles needed for your layout */
//     /* For example, if you have elements that are hidden on screen but needed in print */
//     @media print {
//         /* Styles specific for print */
//     }
//   `;
//   document.head.appendChild(style);


//   // Generate custom filename with timestamp (already in your code)
//   const now = new Date();
//   const formattedDate = now.toLocaleDateString('en-GB').replace(/\//g, '-');
//   const formattedTime = now.toLocaleTimeString('en-GB').replace(/:/g, '-');
//   const fileName = `HCS-CodingPathHistory-${formattedDate}-${formattedTime}.pdf`;

//   // Download PDF with html2pdf options (already in your code)
//   const options = {
//     margin: [0.5, 0.5, 0.5, 0.5], // Set all margins (top, left, bottom, right)
//     filename: fileName,
//     image: { type: 'jpeg', quality: 0.98 },
//     html2canvas: {
//         scale: 2,
//         logging: true,
//         useCORS: true,
//         // windowHeight: element.scrollHeight, // Sometimes helps, but modifying styles is more reliable
//         // height: element.scrollHeight // Also sometimes helps
//     },
//     jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }, // A4 format, portrait orientation
//     pagebreak: { mode: 'auto', before: '.page-break' }, // Automatic page breaks
//   };

//   // Set options for html2pdf and create the PDF
//   html2pdf().set(options).from(element).save().then(() => {
//     // 3. Restore original styles and remove added style tag after PDF is generated
//     element.style.height = originalStyle.height;
//     element.style.overflow = originalStyle.overflow;
//     element.style.maxHeight = originalStyle.maxHeight;
//     // Restore parent styles if you modified them
//     // parentElement.style.height = originalParentStyle.height;

//     // Clean up the added style tag
//     if (style.parentNode) {
//         style.parentNode.removeChild(style);
//     }
//   }).catch(err => {
//       console.error("Error generating PDF:", err);
//       // Also restore styles in case of an error
//       element.style.height = originalStyle.height;
//       element.style.overflow = originalStyle.overflow;
//       element.style.maxHeight = originalStyle.maxHeight;
//       if (style.parentNode) {
//         style.parentNode.removeChild(style);
//       }
//   });
// };